import axios from 'axios';
import fileDownload from 'js-file-download';
const CONTROLLER_PATH = 'File';

class FileService {
    //CREATE

    //READ
    get(fileId, namePrefix) {
        axios
            .get(CONTROLLER_PATH + '/' + fileId, {
                params: {namePrefix: namePrefix},
                responseType: 'blob',
                timeout: 0,
            })
            .then(function(response) {
                fileDownload(response.data, response.headers['content-disposition'].match(/filename\s*=\s*(.+);/i)[1]);
            });
    }

    //UPDATE

    //DELETE
}

export default new FileService();
